import { colors, size } from '@styles/theme'
import styled from '@emotion/styled'

import { Button } from '@mui/material'

const ActionButton = styled(Button)`
  background-color: ${colors.statusColors.right_now('primary')};
  color: white;
  width: 100%;
  flex-shrink: 0;
  padding: ${size(1.5)} 0;
  border-radius: 100px;
  font-weight: bold;
`

const GradientActionButton = styled(ActionButton)`
  // background: linear-gradient(139deg, #1976D2 23.12%, #1DE4D0 108.2%);
  background: linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%);
  color: white;
`

export { ActionButton, GradientActionButton }